 
 
import React from 'react';
import { TCompleteAssetSchema } from '@brickwise/asset-validation/dist/schema/completeAsset';

export const AssetContext = React.createContext({
  asset: {} as TCompleteAssetSchema & { useSerialNumber?: boolean },
  refreshAsset: () => {},
  isEditable: true,
  isAllowDocumentUpload: true,
});

export const useAsset = () => React.useContext(AssetContext);
